import { render } from "./login_simple.vue?vue&type=template&id=447cee3e"
import script from "./login_simple.vue?vue&type=script&lang=js"
export * from "./login_simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__